<template lang="html">
  <!-- <router-view/> -->
  <div class="labs">


      <!-- <div class="sidebar">
        <div class="heading">
          <h1>{{$ml.get(`Labs`)}}</h1>
        </div>
        <aside>

          <div class="search-labs">
            <searchInput v-model="searchQuery" />
          </div>

          <nav>


            <SelectorOverlayContainer
              v-if="labs.length"
              :value="$route.params.id"
              :react-on="labs"
            >
              <SelectorOverlayItem
                v-for="item in labs"
                :key="item.id"

                :class="{ is_active : (item.id == $route.params.id) }"
              >
                <router-link class="list-item" :to="`/dashboard/labs/${item.id}`">
                  <div :class="{ '--selector-overlay-pointer' : (item.id == $route.params.id) }">
                    <span class="">{{item.name}}</span>
                    <span class="sub">{{item.country}}</span>
                  </div>
                </router-link>
              </SelectorOverlayItem>
            </SelectorOverlayContainer>

          </nav>

        </aside>
      </div> -->

      <!-- <div class="content">
        <router-view v-model="this.$route.params.id"/>
      </div> -->

      <MobileSidebarWrapper id="labs" param="id">
      <template slot="sidebar">
        <div class="sidebar-lab">
          <div class="heading">
            <h1>{{$ml.get(`Labs`)}}</h1>

            <app-btn
              @click="$store.dispatch('labs/popup/open', {open: true, isNew: true})"
            >
              {{ $ml.get(`add`) }}
            </app-btn>
          </div>
          <aside>

            <div class="search-labs">
              <SearchInput delayed @input="setSearch" />
            </div>

            <nav>


              <SelectorOverlayContainer
                
                :value="$route.params.id"
                :react-on="labs"
              >
                <SelectorOverlayItem
                  v-for="item in labs"
                  :key="item.id"

                  :class="{ is_active : (item.id == $route.params.id) }"
                >
                  <router-link class="list-item" :to="`/dashboard/labs/${item.id}`" >
                    <div class="--selector-overlay-pointer" :class="{ 'router-link-active' : (item.id == $route.params.id) }">
                      <span class="">{{item.name}}</span>
                      <span class="sub">{{item.country}}</span>
                    </div>
                  </router-link>
                </SelectorOverlayItem>
              </SelectorOverlayContainer>

              
            </nav>

          </aside>
          
        </div>
      </template>
      <template slot="content">
         <div class="content">
          <router-view v-model="this.$route.params.id"/>
        </div>
      </template>
    </MobileSidebarWrapper>

    <Popup />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SearchInput from '@/components/common/SearchInput';
import MobileSidebarWrapper from '@/components/common/mobile-sidebar-wrapper/MobileSidebarWrapper'
import {
  SelectorOverlayContainer,
  SelectorOverlayItem
} from '@/components/common/selector-overlay'
import Popup from '@/components/labs/popup/Popup'

export default {
  data() {
    return {
      loading: false
      // searchQuery : null,
      // test: [
      //   {id: 1, name: 'test1', country: 'test1'},
      //   {id: 2, name: 'test1', country: 'test1'},
      //   {id: 3, name: 'test1', country: 'test1'},
      //   {id: 4, name: 'test1', country: 'test1'},
      // ]
    }
  },
  methods : {
    //=================================================================================
    sync() {
      this.$store.dispatch('labs/loadLabs')
      .then(res=>{})
      .catch(err=>{
        this.$notify({
                  group: "notices",
                  title: this.$ml.get(
                    `Please buy a plan before searching labs.`
                  ),
                  type: "error",
                });
      })
      this.$store.dispatch('labs/loadAllExt');
    },
    //=================================================================================
    setSearch (val) {
      this.$store.commit('labs/setSearch', val);
      this.sync();
    }
  },
  created() {
    this.sync();
  },
  computed : {
    ...mapGetters({
      labs: 'labs/data',
    }),
  },
  components: {
    SearchInput,
    SelectorOverlayContainer,
    SelectorOverlayItem,
    MobileSidebarWrapper,
    Popup
  }
}
</script>

<style lang="scss" scoped>
.root-sidebar {
  background: red;
}
.labs {
  padding: 8px;
  display: flex;
  flex-direction: row;
  .heading {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 768px) {
      min-height: 50px;
    }
  }

  .search-labs {
    padding-bottom: 20px;
  }

  .sidebar-lab {
    width: 320px;
    // width: 100%;
    display: flex;
    flex-direction: column;
    height: 100%;

    aside {
      border: 1px solid #E4E5E6;
      // display: block;
      @media (max-width: 768px) {
        height: auto;
      }

      nav {
        height: calc(100vh - 253px);
        overflow-y: auto;
        scrollbar-width: thin;
        // ul {
        //   margin: 0;
        //   padding: 0;
        //   display: flex;
        //   flex-direction: column;

        //   li {
        //     list-style-type: none;
        //     border-bottom: 1px solid #E0E0E0;
        //     display: flex;
        //     flex-direction: column;
        //     padding-bottom: 4px;
        //     margin-bottom: 4px;
        //     &.is_active {
        //       > a {
        //         background-color: $mainGreen;
        //         color: #fff;
        //         span.sub {
        //           color: #fff;
        //         }
        //       }
        //     }
        //     a {
        //       width: 100%;
        //       padding: 8px 16px;
        //       color: #4C5056;
        //       font-size: 18px;
        //       font-weight: 500;
        //       border-radius: 5px;
        //       overflow: hidden;
        //       display: flex;
        //       flex-direction: column;
        //       // align-items: center;
        //       // justify-content: space-between;
        //       // transition: .3s;
        //       span.sub {
        //         font-size: 12px;
        //         color: #8B8D91;
        //         text-transform: uppercase;
        //         padding-top: 6px;
        //       }
        //     }
        //   }
        // }

        a.list-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          position: relative;

          padding: 5px 0;
          border-top: 1px solid rgba(76, 80, 86, 0.1);

          >div {
            width: 100%;
            padding: 8px 20px;
            color: #4C5056;
            font-size: 18px;
            font-weight: 500;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            transition: color 0.5s ease;

            &.router-link-active {
              // background-color: $mainGreen;
              color: #fff;
              span.sub {
                color: #fff;
              }
            }
            span.sub {
              font-size: 12px;
              color: #8B8D91;
              text-transform: uppercase;
              padding-top: 6px;
            }
          }

        }
      }


    }
  }
  .content {
    padding-left: 16px;
    flex-grow: 1;
  }
  @media(max-width:768px) {
    .content {
      padding-left: 0;
    }
    aside {
      width: 100%;
    }
  }
}
</style>
